import {useUpmPlant} from '@hconnect/upm'
import {DashboardCard, Loading} from '@hm/fundamental'

import {KilnShutdownsCardBody} from './KilnShutdownsCardBody'
import {KilnShutdownsCardHeader} from './KilnShutdownsCardHeader'

import {useShutdownsQuery} from '@refra/modules/common/hooks/queries'
import {useKilns, ShutdownsProvider} from '@refra/modules/common/providers'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const KilnShutdownsCard: React.FC = () => {
  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode})

  const {selectedKiln} = useKilns()

  const {data: shutdowns} = useShutdownsQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  if (!shutdowns) {
    return (
      <DashboardCard className="flex justify-center">
        <Loading size="large" data-cy="kiln_shutdowns_card_loader" />
      </DashboardCard>
    )
  }

  return (
    <ShutdownsProvider shutdowns={shutdowns}>
      <DashboardCard data-cy="kiln_shutdowns_card">
        <div className="flex flex-col gap-6">
          <KilnShutdownsCardHeader />
          <KilnShutdownsCardBody />
        </div>
      </DashboardCard>
    </ShutdownsProvider>
  )
}
